App.controller('LifeCtrl', ['$rootScope', '$scope', '$sce', '$state', function ($rootScope, $scope, $sce, $state) {
    if (!$rootScope.CONFIGURATOR.isLifeInsuranceEnabled && !$rootScope.CONFIGURATOR.isLifeInsuranceWithPaymentsEnabled) {
        var redirectRouteName;

        if ($rootScope.CONFIGURATOR.isHealthInsuranceEnabled) {
            redirectRouteName = 'root.home.healthInsurance.list';
        } else if ($rootScope.CONFIGURATOR.healthInsuranceWithPayments.isEnabled) {
            // TODO-MZ
            redirectRouteName = 'root.home.healthInsuranceWithPayments.list';
        } else {
            redirectRouteName = 'root.home.insurance.list';
        }

        $state.go(redirectRouteName);
    }
}]);
